import { Spinner } from "@jkast90/kast-common/ui";

/** The fallback shown while a lazily loaded page or component downloads. */
export default function PageLoading() {
  return (
    <div style={{ padding: "2rem" }}>
      <Spinner size="lg" label="Loading…" />
    </div>
  );
}
